import { createSlice } from "@reduxjs/toolkit";

import { getDirectDebt, getDirectDebtDiscovery } from "./actions/directDebt.thunk";
import * as reducers from "./reducers/directDebt.reducers";
import { DirectDebtState } from "../../../utils/types";

export const initialState: DirectDebtState = {
  getDirectdebt: {
    loadingStatus: "not loaded",
    error: undefined,
    data: undefined,
  },
  getDirectdebtDiscovery: {
    loadingStatus: "not loaded",
    error: undefined,
    data: undefined,
  },
};

export const DIRECT_DEBT_KEY = "directDebt";

export const directDebtSlice = createSlice({
  name: DIRECT_DEBT_KEY,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDirectDebt.pending, reducers.patchDirectDebtPending)
      .addCase(getDirectDebt.fulfilled, reducers.patchDirectDebtFulfilled)
      .addCase(getDirectDebt.rejected, reducers.patchDirectDebtRejected)
      
      .addCase(getDirectDebtDiscovery.pending, reducers.patchDirectDebtDiscoveryPending)
      .addCase(getDirectDebtDiscovery.fulfilled, reducers.patchDirectDebtDiscoveryFulfilled)
      .addCase(getDirectDebtDiscovery.rejected, reducers.patchDirectDebtDiscoveryRejected);
  },
});

/*
 * Export reducer for store configuration.
 */
export const directDebtReducer = directDebtSlice.reducer;

/*
 * Export action creators to be dispatched. For use with the `useDispatch` hook.
 */
export const directDebtSliceSliceActions = directDebtSlice.actions;
